import React, { ReactNode } from 'react';

import { Tooltip as ReactTooltip } from 'react-bootstrap';
import { OverlayChildren } from 'react-bootstrap/Overlay';
import OverlayTrigger, { OverlayTriggerProps } from 'react-bootstrap/OverlayTrigger';

export type TooltipPropsT = Omit<OverlayTriggerProps, 'delay' | 'overlay' | 'placement'> & {
  tooltipContent: ReactNode;
  hideDelay?: number;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  showDelay?: number;
  tooltipClassName?: string;
};
export type TooltipT = React.FC<TooltipPropsT>;

export const Tooltip: TooltipT = ({
  tooltipContent,
  children,
  hideDelay,
  showDelay,
  tooltipClassName,
  ...tooltipProps
}) => {
  const tooltip: OverlayChildren = (injected) => (
    <ReactTooltip {...injected} className={tooltipClassName}>{tooltipContent}</ReactTooltip>
  );

  return (
    <OverlayTrigger
      delay={{ hide: hideDelay || 0, show: showDelay || 0 }}
      overlay={tooltip}
      {...tooltipProps}
    >
      {children}
    </OverlayTrigger>
  );
};
